import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { RouterModule } from '@angular/router'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap'

import { LocaleModule } from 'common/locale'
import { UtilCommonModule } from 'common/util'
import { LIST_RESOURCE_COMMON_COMPONENTS } from 'common/listResourceController'
import { EntityListModule } from 'common/entityList'
import { UtilReleaseNotesModule } from 'common/util.releaseNotes'
import { LuxonDateTimeModule } from 'common/luxonDateTime'

import { WorkstationsViewComponent } from './views/workstationsView.component'
import { WorkstationViewComponent } from './views/workstationView.component'

@NgModule({
  imports: [
    FormsModule,
    CommonModule,
    EntityListModule,
    LuxonDateTimeModule,
    UtilCommonModule,
    NgbDropdownModule,
    ReactiveFormsModule,
    UtilReleaseNotesModule,
    ...LIST_RESOURCE_COMMON_COMPONENTS,
    LocaleModule.forChild(),
    RouterModule.forChild([
      ...WorkstationsViewComponent.ROUTES,
      ...WorkstationViewComponent.ROUTES,
    ]),
    WorkstationsViewComponent,
    WorkstationViewComponent,
  ],
})
export class WorkstationsModule { }

export default WorkstationsModule
